import { type WorkspaceAgentDisplayRow } from '~/components/v2/components/workspace/workspace-agent-panel/utils/groupWorkspaceAgentMessagesForDisplay';
import { isWorkspaceAgentSessionRunning } from '~/components/v2/components/workspace/workspace-agent-panel/utils/isWorkspaceAgentSessionRunning';

export type GetWorkspaceAgentStreamingMessageIdParams = {
  activeRunId: string | null;
  isAwaitingRunStart: boolean;
  isSending: boolean;
  isSessionProcessing: boolean;
  rows: WorkspaceAgentDisplayRow[];
};

/** Last assistant row id while a run is active and the reply belongs to the latest send. */
export const getWorkspaceAgentStreamingMessageId = ({
  activeRunId,
  isAwaitingRunStart,
  isSending,
  isSessionProcessing,
  rows,
}: GetWorkspaceAgentStreamingMessageIdParams): string | null => {
  const isRunActive = isWorkspaceAgentSessionRunning({
    activeRunId,
    isAwaitingRunStart,
    isSending,
    isSessionProcessing,
  });

  if (!isRunActive) {
    return null;
  }

  const lastAssistantRow = rows.findLast((row) => row.type === 'message' && row.message.role === 'assistant');

  if (lastAssistantRow?.type !== 'message') {
    return null;
  }

  // While a send is in flight and before the first token, the last assistant row is still the
  // PREVIOUS turn's reply. Calling that one streaming would flip its settled chips — an Unavailable
  // reference included — back to the pending pulse.
  const lastUserRow = rows.findLast((row) => row.type === 'message' && row.message.role === 'user');
  const isReplyToLatestSend =
    lastUserRow?.type !== 'message' || lastAssistantRow.message.sequence > lastUserRow.message.sequence;

  return isReplyToLatestSend ? lastAssistantRow.message.id : null;
};
